import React, { Component } from 'react';
import {
	POSITION_INLINE,
	POSITION_LEFT,
	POSITION_CENTER,
	POSITION_RIGHT,
	SIZE_SMALL,
	SIZE_MEDIUM,
	SIZE_LARGE,
	SIZE_FULL,
	SIZE_ORIGINAL
} from '@techchange/pm-specs/src/specs/nodes/image.js';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import { messages } from '../../../../../../_shared/i18n/messages';

// eslint-disable-next-line no-unused-vars
import optionStyles from './ImageOptions.module.scss';
import toolbarStyles from './ImageToolbar.module.scss';

const propTypes = {

	/**
	 * The current 'size' attribute for the image, if any.
	 */
	size: PropTypes.string,

	/**
	 * The current 'position' attribute for the image, if any.
	 */
	position: PropTypes.string,

	/**
	 * The current link mark embedded in the image.
	 */
	link: PropTypes.shape({

		/**
		 * Set of link mark attributes.
		 */
		attrs: PropTypes.shape({

			/**
			 * The link URL.
			 */
			href: PropTypes.string,

		}),

	}),

	/**
	 * Callback for updating attributes of the selected image.
	 */
	onAttrsUpdate: PropTypes.func.isRequired,

	/**
	 * Callback for handling link toggle.
	 */
	onLinkClick: PropTypes.func.isRequired,

	/**
	 * Provider for internationalization, injected by react-intl.
	 */
	intl: PropTypes.shape({

		formatMessage: PropTypes.func.isRequired,

	}).isRequired,


};

class ImageOptions extends Component {

	constructor(props) {

		super(props);

		this.handleAttrsChange = this.handleAttrsChange.bind(this);

	}

	handleAttrsChange(event) {

		const { onAttrsUpdate } = this.props;

		const data = event.currentTarget.id.split('-');
		const attr = data[0], value = data[1];

		onAttrsUpdate({ [attr]: value });

	}

	render() {

		const { position, size, link, onLinkClick, intl } = this.props;

		const iconButtonClass = toolbarStyles['icon-btn'];

		return (
			<div className="d-flex">
				<span
					id={`position-${POSITION_INLINE}`}
					className={`${iconButtonClass} ${position === POSITION_INLINE ? toolbarStyles.active : ''}`}
					title={intl.formatMessage(messages.TC_COMPONENTS_TEXT_EDITOR_IMAGE_INLINE_BUTTON_TITLE)}
					onClick={this.handleAttrsChange}>
					<i className="fas fa-align-slash" />
				</span>
				<span
					id={`position-${POSITION_LEFT}`}
					className={`${iconButtonClass} ${position === POSITION_LEFT ? toolbarStyles.active : ''}`}
					title={intl.formatMessage(messages.TC_COMPONENTS_TEXT_EDITOR_IMAGE_LEFT_ALIGN_BUTTON_TITLE)}
					onClick={this.handleAttrsChange}>
					<i className="fas fa-align-left" />
				</span>
				<span
					id={`position-${POSITION_CENTER}`}
					className={`${iconButtonClass} ${position === POSITION_CENTER ? toolbarStyles.active : ''}`}
					title={intl.formatMessage(messages.TC_COMPONENTS_TEXT_EDITOR_IMAGE_CENTER_BUTTON_TITLE)}
					onClick={this.handleAttrsChange}>
					<i className="fas fa-align-center" />
				</span>
				<span
					id={`position-${POSITION_RIGHT}`}
					className={`${iconButtonClass} ${position === POSITION_RIGHT ? toolbarStyles.active : ''}`}
					title={intl.formatMessage(messages.TC_COMPONENTS_TEXT_EDITOR_IMAGE_RIGHT_ALIGN_BUTTON_TITLE)}
					onClick={this.handleAttrsChange}>
					<i className="fas fa-align-right" />
				</span>
				<div
					className={`mx-2 ${toolbarStyles.divider}`} />
				<span
					id={`size-${SIZE_SMALL}`}
					className={`${iconButtonClass} ${optionStyles.small} ${size === SIZE_SMALL ? toolbarStyles.active : ''}`}
					title={intl.formatMessage(messages.TC_COMPONENTS_TEXT_EDITOR_IMAGE_SMALL_BUTTON_TITLE)}
					onClick={this.handleAttrsChange}>
					<i className="far fa-square" />
				</span>
				<span
					id={`size-${SIZE_MEDIUM}`}
					className={`${iconButtonClass} ${optionStyles.medium} ${size === SIZE_MEDIUM ? toolbarStyles.active : ''}`}
					title={intl.formatMessage(messages.TC_COMPONENTS_TEXT_EDITOR_IMAGE_MEDIUM_BUTTON_TITLE)}
					onClick={this.handleAttrsChange}>
					<i className="far fa-square" />
				</span>
				<span
					id={`size-${SIZE_LARGE}`}
					className={`${iconButtonClass} ${optionStyles.large} ${size === SIZE_LARGE ? toolbarStyles.active : ''}`}
					title={intl.formatMessage(messages.TC_COMPONENTS_TEXT_EDITOR_IMAGE_LARGE_BUTTON_TITLE)}
					onClick={this.handleAttrsChange}>
					<i className="far fa-square" />
				</span>
				<span
					id={`size-${SIZE_FULL}`}
					className={`${iconButtonClass} ${size === SIZE_FULL ? toolbarStyles.active : ''}`}
					title={intl.formatMessage(messages.TC_COMPONENTS_TEXT_EDITOR_IMAGE_FULL_WIDTH_BUTTON_TITLE)}
					onClick={this.handleAttrsChange}>
					<i className="far fa-arrow-left-to-line" />
					<i className="far fa-arrow-right-to-line" />
				</span>
				<span
					id={`size-${SIZE_ORIGINAL}`}
					className={`${iconButtonClass} ${size === SIZE_ORIGINAL ? toolbarStyles.active : ''}`}
					title={intl.formatMessage(messages.TC_COMPONENTS_TEXT_EDITOR_IMAGE_ORIGINAL_BUTTON_TITLE)}
					onClick={this.handleAttrsChange}>
					<i className="fas fa-undo-alt" />
				</span>
				<div
					className={`mx-2 ${toolbarStyles.divider}`} />
				<span
					className={`${iconButtonClass} ${link ? toolbarStyles.active : ''}`}
					title={intl.formatMessage(messages.TC_COMPONENTS_TEXT_EDITOR_IMAGE_LINK_BUTTON_TITLE)}
					onClick={onLinkClick}>
					<i className="fas fa-link" />
				</span>
			</div>
		);

	}

}

ImageOptions.propTypes = propTypes;

export default injectIntl(ImageOptions);
